import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import { duelService } from '../../../services/socialService';
import { notificationService } from '../../../services/notificationService';

const DuelNotificationActions = ({ notification, onActionComplete }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [actionTaken, setActionTaken] = useState(false);

  const duelId = notification?.metadata?.duel_id;
  const fromUserId = notification?.metadata?.from_user_id;

  const handleAccept = async (e) => {
    e?.stopPropagation();
    if (!duelId) return;

    setLoading(true);
    try {
      // Accept the duel
      await duelService?.acceptDuel(duelId, notification?.user_id);
      
      // Mark notification as read
      await notificationService?.markAsRead(notification?.id);
      
      setActionTaken(true);
      onActionComplete?.();
      
      // Navigate to social hub to view the duel
      setTimeout(() => {
        navigate('/social-hub');
      }, 500);
    } catch (error) {
      console.error('Error accepting duel:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDecline = async (e) => {
    e?.stopPropagation();
    if (!duelId) return;

    setLoading(true);
    try {
      // Cancel the duel
      await duelService?.cancelDuel(duelId, notification?.user_id);
      
      // Mark notification as read
      await notificationService?.markAsRead(notification?.id);
      
      setActionTaken(true);
      onActionComplete?.();
    } catch (error) {
      console.error('Error declining duel:', error);
    } finally {
      setLoading(false);
    }
  };

  if (actionTaken) {
    return (
      <div className="text-sm text-success font-medium">
        ✓ Acción completada
      </div>
    );
  }

  return (
    <div className="flex items-center space-x-2">
      <Button
        variant="solid"
        size="xs"
        onClick={handleAccept}
        disabled={loading}
        iconName="Check"
        className="bg-success hover:bg-success/90 text-white"
      >
        {loading ? 'Aceptando...' : 'Aceptar'}
      </Button>
      <Button
        variant="outline"
        size="xs"
        onClick={handleDecline}
        disabled={loading}
        iconName="X"
        className="border-error text-error hover:bg-error/10"
      >
        {loading ? 'Rechazando...' : 'Rechazar'}
      </Button>
    </div>
  );
};

export default DuelNotificationActions;